module.exports = __webpack_public_path__ + "static/media/d1.fa91805a.jpg";